var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container px-0"},[_c('SectionWrapper',{attrs:{"title":_vm.$t('solutions.title'),"link":_vm.getRouteBaseName() !== 'services'
                ? { path: _vm.localePath('/services'), label: _vm.$t('generic.read_more') }
                : null,"is-carousel-wrapper":""}},[_c('ServicesCarousel',{attrs:{"services":_vm.services}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }